<template id="app">
  <div style="position: relative; width: 100%;">
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <CCardBody>
          <v-card shaped>
            <GmapMap
              :center="center"
              v-bind:zoom="zoom"
              @zoom_changed="updateZoomLevel"
              map-type-id="satellite"
              ref="mapRef"
              :options="mapOptions"
              :style="{ width: '100%', height: mapHeight }"
              @click="handleMapClick"
            >
              <GmapMarker
                v-if="loadingMarker.shouldDisplayLoadingMarker"
                v-bind:position="loadingMarker.position"
                :icon="loadingMarker.icon"
              />
              <GmapMarker
                v-for="(marker, index) in clickedPoints"
                v-bind:key="index + '-add'"
                :position="marker.position"
                :icon="{
                  url: require('../assets/icons/add.png'),
                  scaledSize: { width: 20, height: 20 },
                }"
              />

              <GmapPolygon
                :paths="polygonPaths"
                :options="{
                  strokeColor: '#fcf003',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: '#93c47e',
                  fillOpacity: 0.35,
                }"
              />

              <!--  polygons initiale  -->
              <div v-for="(item, index) in polygons" :key="item._id">
                <GmapPolygon
                  :key="index"
                  :ref="`polygon-${item._id}-${index}`"
                  :paths="item.Coord"
                  :options="getPolygonOptions(item)"
                  @click="onPolygonClick(item)"
                  @mouseover="onPolygonMouseOver(item)"
                  @mouseout="onPolygonMouseOut(item)"
                  @paths_changed="onPolygonDragEnd($event, item, index)"
                />

                <GmapMarker
                  :key="`marker-${index}`"
                  :position="getPolygonCenter(item.Coord)"
                  :label="
                    mapZoom > 15
                      ? {
                          text: `${item.name}`,
                          color: '#FFF',
                          fontSize: '14px',
                          fontWeight: 'bold',
                        }
                      : null
                  "
                  :icon="{
                    url: '../assets/icons/transparent.png',
                    size: { width: 0, height: 0 },
                  }"
                />
              </div>

              <!--       <GmapMarker
                v-bind:key="index"
                v-for="(m, index) in markers"
                v-bind:position="m.position"
                :title="m.title"
                v-bind:clickable="true"
                v-bind:draggable="false"
                @click="profilePath(m.position, m.id)"
                :icon="{
                  url: require('../assets/icons/ico_marker.png'),
                  scaledSize: { width: 60, height: 50 },
                }"
              /> -->

              <div
                v-for="(poly, index) in polygons_satte"
                :key="JSON.stringify(poly)"
              >
                <GmapPolygon
                  :paths="poly.coords"
                  :options="getPolygonOptions2(poly)"
                  @click="toggleInfoWindow(index, $event)"
                  @mouseover="onMouseoverPolygon(poly)"
                  @mouseout="onMouseoutPolygon(poly)"
                >
                </GmapPolygon>

                <GmapInfoWindow
                  :position="infoWindowPos"
                  :opened="currentPolygonIndex === index"
                  @closeclick="
                    (infoWindowPos = null), (currentPolygonIndex = null)
                  "
                >
                  <div
                    style="background-color: #F8F9FA; padding: 10px; border-radius: 10px; box-shadow: 0 0 10px rgba(0,0,0,0.2);"
                  >
                    <p style="margin: 0; color: #6c757d;">
                      Soil Moisture: {{ poly.properties }}
                    </p>
                  </div>
                </GmapInfoWindow>
              </div>

              <GmapPolyline
                :path="polylinePath"
                :options="{
                  strokeColor: '#fcf003',
                  strokeOpacity: 1.0,
                  strokeWeight: 3,
                }"
              />
            </GmapMap>

            <div class="map-controls" v-show="show_info_sattelite == false">
              <!-- <button
                class="map-button"
                :class="{ 'active-button': edit_active }"
                @click="oneditbuttonclick()"
              >
                <i
                  :class="edit_active ? 'fas fa-save' : 'fas fa-pencil-alt'"
                ></i>
                {{ edit_active ? "Sauvegarder" : "Ajuster les Polygones" }}
              </button> -->
              <button
                class="map-button"
                :class="{ 'active-button': activeClick }"
                @click="AddParcel()"
              >
                <i
                  :class="
                    activeClick === false ? 'fas fa-pencil-alt' : 'fas fa-times'
                  "
                ></i>
                Ajouter Parcelle
              </button>
            </div>

            <div v-show="show_info_sattelite == true">
              <div class="map-profondeur">
                <button
                  class="map-button-profondeur"
                  :class="{ 'active-button': profendeur === '10 cm' }"
                  @click="selectButtonprof('10 cm')"
                >
                  <i class="fas fa-ruler-vertical"></i> 10 cm
                </button>

                <button
                  class="map-button-profondeur"
                  :class="{ 'active-button': profendeur === '25 cm' }"
                  @click="selectButtonprof('25 cm')"
                >
                  <i class="fas fa-ruler-vertical"></i> 25 cm
                </button>

                <button
                  class="map-button-profondeur"
                  :class="{ 'active-button': profendeur === '40 cm' }"
                  @click="selectButtonprof('40 cm')"
                >
                  <i class="fas fa-ruler-vertical"></i> 40 cm
                </button>

                <button
                  class="map-button-profondeur"
                  :class="{ 'active-button': profendeur === '55 cm' }"
                  @click="selectButtonprof('55 cm')"
                >
                  <i class="fas fa-ruler-vertical"></i> 55 cm
                </button>
              </div>

              <template>
                <div class="chart-controls">
                  <div
                    class="map-check"
                    :class="{ checked: checkboxchartet0 }"
                    @click="
                      (checkboxchartet0 = !checkboxchartet0),
                        (checkboxchart = false)
                    "
                  >
                    <i
                      :class="
                        checkboxchartet0
                          ? 'fas fa-check-square'
                          : 'far fa-square'
                      "
                    ></i>
                    <span class="label-text"> ET0</span>
                  </div>

                  <div
                    class="map-check"
                    :class="{ checked: checkboxchart }"
                    @click="
                      (checkboxchart = !checkboxchart),
                        (checkboxchartet0 = false)
                    "
                  >
                    <i
                      :class="
                        checkboxchart ? 'fas fa-check-square' : 'far fa-square'
                      "
                    ></i>
                    <span class="label-text"> Évolution</span>
                  </div>
                </div>
              </template>

              <div
                v-show="checkboxchart"
                id="chartContainer"
                style="position: absolute; top: 5rem; left: 6rem; width: 450px; height: 230px; z-index: 2; background-color: #428874"
              >
                <CChartLine
                  :datasets="defaultDatasets"
                  :options="defaultOptions"
                  :labels="labels"
                />
              </div>

              <div
                v-show="checkboxchartet0"
                id="chartContainer"
                style="position: absolute; top: 5rem; left: 6rem; width: 450px; height: 230px; z-index: 2; background-color: #428874"
              >
                <CChartLine
                  :datasets="defaultDatasetset0"
                  :options="defaultOptionset0"
                  :labels="labelset0"
                />
              </div>

              <div class="map-controls">
                <button
                  class="map-button"
                  :class="{ 'active-button': activeButton === 'Absolu' }"
                  @click="selectButton('Absolu')"
                >
                  <i class="fas fa-arrows-alt-h"></i> Absolu
                </button>

                <button
                  class="map-button"
                  :class="{ 'active-button': activeButton === 'Relatif' }"
                  @click="selectButton('Relatif')"
                >
                  <i class="fas fa-crosshairs"></i> Relatif
                </button>
              </div>

              <div id="gradient-bar" v-show="activeButton === 'Absolu'">
                <div class="label-top">Humidité élevée</div>
                <div class="bar-container">
                  <div class="value">100%</div>
                  <div class="value">83%</div>
                  <div class="value">67%</div>
                  <div class="value">50%</div>
                  <div class="value">33%</div>
                  <div class="value">17%</div>
                  <div class="value">0%</div>
                </div>
                <div class="label-bottom">Humidité faible</div>
              </div>

              <div
                id="gradient-barbarminmax"
                v-show="activeButton === 'Relatif'"
              >
                <div class="label-top">Humidité élevée</div>

                <div class="bar-container">
                  <div class="valueminmax">{{ VALUE_MAX }}%</div>
                  <div class="valueminmax">{{ averageValue }}%</div>
                  <div class="valueminmax">{{ VALUE_MIN }}%</div>
                </div>

                <div class="label-bottom">Humidité faible</div>
              </div>

              <div class="select-date">
                <select v-model="selectedYear" class="date-dropdown">
                  <option disabled value="">Sélectionnez l'année</option>
                  <option
                    v-for="year in yearOptions"
                    :key="year"
                    :value="year"
                    >{{ year }}</option
                  >
                </select>

                <select v-model="selectedMonth" class="date-dropdown">
                  <option disabled value="">Sélectionnez le mois</option>
                  <option
                    v-for="month in monthOptions"
                    :key="month.value"
                    :value="month.value"
                    >{{ month.text }}</option
                  >
                </select>
              </div>

              <div class="map-start">
                <button
                  class="map-button"
                  :class="{ 'active-button': playing }"
                  @click="play_show()"
                >
                  <i :class="playing ? 'fas fa-pause' : 'fas fa-play'"></i>

                  <span>{{ playing ? "  Stop" : "  Début" }}</span>
                </button>
              </div>
            </div>

            <vue-google-autocomplete
              v-if="activeClick"
              id="search"
              ref="autocomplete"
              v-model="autocompleteInput"
              @placechanged="getAddressData"
              types="(cities)"
              placeholder="Tapez le nom d'une ville"
              style=" width :35%;position: absolute; top: 15%; left: 10px; transform: translate(0, -50%); background-color: white; border: 1px solid #ccc; border-radius: 2px; box-shadow: 0 1px 4px rgba(0,0,0,0.3); cursor: pointer; padding: 6px;"
            ></vue-google-autocomplete>

            <button
              v-if="clickedPoints.length > 0"
              style="width :3.5%;position: absolute; top: 50%; right: 10px; transform: translate(0, -50%); background-color: white; border: 1px solid #ccc; border-radius: 2px; box-shadow: 0 1px 4px rgba(0,0,0,0.3); cursor: pointer; padding: 6px;"
              @click="deleteLastPoint"
            >
              <i style="color:#428874" class="fas fa-trash"></i>
            </button>
            <button
              v-if="clickedPoints.length > 2"
              style=" width :3.5%;position: absolute; top: 55%; right: 10px; transform: translate(0, -50%); background-color: white; border: 1px solid #ccc; border-radius: 2px; box-shadow: 0 1px 4px rgba(0,0,0,0.3); cursor: pointer; padding: 6px;"
              @click="openModal"
            >
              <i style="color:#428874" class="fas fa-save"></i>
            </button>
          </v-card>
          <div
            class="carousel-wrapper"
            style="position: absolute; bottom: 0; left: 0; right: 0; z-index: 2; margin-bottom: 9px;"
          >
            <div class="container">
              <div class="scrolling-wrapper">
                <div
                  class="card1"
                  @click="handleCardClick(item)"
                  v-for="(item, index) in carouselItems"
                  :key="index"
                  :class="{ 'selected-card': selectedCard === item.key }"
                >
                  <div class="card1-body">
                    <p
                      class="card1-title"
                      :class="{ 'selected-text': selectedCard === item.key }"
                    >
                      {{ item.title }}
                    </p>
                    <p
                      class="card1-text"
                      :class="{ 'selected-text': selectedCard === item.key }"
                    >
                      {{ item.description }}
                    </p>
                  </div>
                  <img
                    :src="item.image"
                    class="card1-img-top"
                    alt="Card Image"
                    style="width: 26px; margin-bottom: 10px;"
                  />
                </div>
              </div>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <polygon-modal
      :show="showModal"
      :area="area"
      :polygonData="currentPolygon"
      @close="showModal = false"
      @save="handleSavePolygon"
    ></polygon-modal>
  </div>
</template>

<script>
import Vue from 'vue';

import { API_KEY } from "./API_KEY";
import { Loader, LoaderOptions } from "google-maps";
import router from "@/routes";
import Node from "../services/NodeData";
import Parcel from "../services/Parcel";
import isEmpty from "@/outils/isEmpty";
import { CChartLine } from "@coreui/vue-chartjs";
import { Carousel, Slide } from "vue-carousel";
import PolygonModal from "../components/PolygonModal.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import MarkerClusterer from "@google/markerclustererplus";

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

Vue.use(Toast, {
    // You can set your default toast options here
    position: 'bottom-right',
    timeout: 2200,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true
});



const loader = new Loader(API_KEY);

export default {
  components: {
    VueGoogleAutocomplete,
    CChartLine,
    Carousel,
    Slide,
    PolygonModal,
  },
  data() {
    return {
      selected_polygon: null,
      yearOptions: [2023, 2024],
      monthOptions: [
        { value: 1, text: "Janvier" },
        { value: 2, text: "Février" },
        { value: 3, text: "Mars" },
        { value: 4, text: "Avril" },
        { value: 5, text: "Mai" },
        { value: 6, text: "Juin" },
        { value: 7, text: "Juillet" },
        { value: 8, text: "Août" },
        { value: 9, text: "Septembre" },
        { value: 10, text: "Octobre" },
        { value: 11, text: "Novembre" },
        { value: 12, text: "Décembre" },
      ],
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,

      mapOptions: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
      },
      map: null,
      clusterer: null,
      autocompleteInput: "",
      activeClick: false,
      showModal: false,
      currentPolygon: null,
      checkboxchartet0: false,
      checkboxchart: false,
      defaultDatasetset0: [
        {
          label: "ET0",
          data: [],
          borderColor: "#40E0D0",
        },
      ],
      labelset0: [],
      defaultDatasets: [
        {
          label: "Humidité à 10 cm", // Name of your first value
          data: [], // Your array of first values
          borderColor: "#f87979", // You can customize the color and other parameters of each line
        },
        {
          label: "Humidité à 25 cm", // Name of your second value
          data: [], // Your array of second values
          borderColor: "#7c79f8",
        },
        {
          label: "Humidité à 40 cm", // Name of your third value
          data: [], // Your array of third values
          borderColor: "#79f883",
        },
        {
          label: "Humidité à 55 cm", // Name of your fourth value
          data: [], // Your array of fourth values
          borderColor: "#f8d279",
        },
      ],
      labels: [],

      defaultOptions: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white", // Change the color of the x-axis labels
                fontSize: 14, // Change the font size of the x-axis labels
              },
              gridLines: {
                color: "rgba(255, 255, 255, 0.1)", // Change the grid lines color
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white", // Change the color of the y-axis labels
                fontSize: 14, // Change the font size of the y-axis labels
              },
              gridLines: {
                color: "rgba(255, 255, 255, 0.1)", // Change the grid lines color
              },
            },
          ],
        },
        elements: {
          line: {
            tension: 0.1,
            borderColor: "white", // Change the line color
            borderWidth: 2,
          },
          point: {
            backgroundColor: "white", // Change the point color
          },
        },
        legend: {
          labels: {
            fontColor: "white", // Change the legend color
            fontSize: 14,
          },
        },
      },
      defaultOptionset0: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
          display: true,
          text: "Évapotranspiration mm/jour",
          fontColor: "white", // adjust as needed
          fontSize: 18,
          fontFamily: "'San Francisco', Arial, sans-serif", // adjust as needed
        },

        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white",  
                fontSize: 12,  
              },
              gridLines: {
                color: "rgba(255, 255, 255, 0.1)",  
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: false,
                fontColor: "white", // Change the color of the y-axis labels
                fontSize: 12, // Change the font size of the y-axis labels
              },
              gridLines: {
                color: "rgba(255, 255, 255, 1)", // Change the grid lines color
              },
            },
          ],
        },
        elements: {
          line: {
            tension: 0.1,
            borderColor: "#FF0000", // Change the line color
            borderWidth: 2,
          },
          point: {
            backgroundColor: "white", // Change the point color
          },
        },
        legend: {
          labels: {
            fontColor: "white", // Change the legend color
            fontSize: 14,
          },
        },
      },
      nodes: null,
      edit_active: false,
      stop_position: 0,
      playing: false,
      VALUE_MAX: 1,
      VALUE_MIN: 1,
      activeButton: "Absolu",
      profendeur: "10 cm",
      itemselect: null,
      loadingMarker: {
        position: { lat: 0, lng: 0 },
        icon: "",
        shouldDisplayLoadingMarker: false,
      },
      mapHeight: null,
      selectedCard: null,
      carouselItems: [],
      list_polygonsatt: [],
      infoWindowPos: null,
      currentPolygonIndex: null,
      show_info_sattelite: false,
      polygons_satte: [],
      polygons: [],
      polygons_initiale: [],
      newpath_tosave: [],
      polygons_selecionne: null,
      center: { lat: 31.792305, lng: -7.080168 },
      zoom: 5,
      markers: [],
      markersadd: [],
      p1: "",
      p2: "",
      p3: "",
      p4: "",
      p5: "",
      p6: "",
      nbr_port: "",
      prf: "",
      clickedPoints: [],
      polylinePath: [],
      polygonPaths: [],
      area: 0,
      mapZoom: 5,
    };
  },
  computed: {
    averageValue() {
   
      const min = parseFloat(this.VALUE_MIN);
      const max = parseFloat(this.VALUE_MAX); 

      if (isNaN(min) || isNaN(max)) return 0;

      return ((min + max) / 2).toFixed(1);
    },
  },
  methods: {
    initMarkerCluster() {
      if (
        this.markers.length > 0 &&
        this.$refs.mapRef &&
        this.$refs.mapRef.$mapObject
      ) {
        const map = this.$refs.mapRef.$mapObject;
        const googleMarkers = this.markers.map(
          (m) =>
            new google.maps.Marker({
              position: m.position,
              title: m.title,
              icon: {
                url: require("../assets/icons/ico_marker.png"),
                scaledSize: new google.maps.Size(60, 50),
              },
            })
        );

        googleMarkers.addListener("click", () => {
          console.log("click");
          this.profilePath(
            { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) },
            item.NodeId
          );
        });

        new MarkerClusterer(map, googleMarkers, {
          imagePath:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
        });
      } else {
        console.log("Markers or map not ready.");
      }
    },

    initMarkers() {
      Node.getNodes().then((res) => {
        const googleMarkers = res.map((item) => {
          const marker = new google.maps.Marker({
            position: {
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            },
            map: this.map,
            title: item.FarmerName,
            icon: {
              url: require("../assets/icons/ico_marker.png"),
              scaledSize: new google.maps.Size(60, 50),
            },
          });

          marker.addListener("click", () => {
            console.log("click");
            this.profilePath(
              {
                lat: parseFloat(item.latitude),
                lng: parseFloat(item.longitude),
              },
              item.NodeId
            );
          });

          return marker;
        });

        this.clusterer = new MarkerClusterer(this.map, googleMarkers, {
          imagePath:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
        });
      });
    },

    updateZoomLevel(e) {
      this.mapZoom = e;
    },
    calculatePolygonArea(coords) {
      const googleCoords = coords.map(
        (coord) => new google.maps.LatLng(coord.lat, coord.lng)
      );
      const areaInSquareMeters = google.maps.geometry.spherical.computeArea(
        googleCoords
      );
      const areaInHectares = areaInSquareMeters / 10000;
      return areaInHectares.toFixed(2);
    },

    handleMapClick(event) 
    {
      this.show_info_sattelite = false;
      
      this.mapOptions = {
        ...this.mapOptions,
        zoomControl: true,
        mapTypeControl: true,
      };

      if (this.activeClick) {
        this.draw(event);
      } else {
        this.edit_active = false;
        this.carouselItems = [];
        this.polygons_satte = [];
        this.polygons = [];
        this.stop_position = 0;
        this.polygons = JSON.parse(JSON.stringify(this.polygons_initiale));
      }
    },
    AddParcel() {
      this.activeClick = !this.activeClick;
      if (this.activeClick == false) {
        this.clickedPoints = [];
        this.clickedPoints = [];
        this.polylinePath = [];
        this.polygonPaths = [];
      }
    },
    openModal() {
      this.currentPolygon = [];
      this.currentPolygon = this.clickedPoints;
      this.positions = this.clickedPoints.map((item) => {
        return {
          lat: item.position.lat,
          lng: item.position.lng,
        };
      });
      this.area = this.calculatePolygonArea(this.positions);
      this.showModal = true;
    },
    handleSavePolygon(polygonDetails) {
      console.log(polygonDetails);
      this.showModal = false;
    },
    getPolygonCenter(coords) {
      let totalLat = 0;
      let totalLng = 0;
      for (const coord of coords) {
        totalLat += coord.lat;
        totalLng += coord.lng;
      }
      return { lat: totalLat / coords.length, lng: totalLng / coords.length };
    },
    onPolygonDragEnd(mvcArray, item) {
      let polygons_edited = this.polygons.filter((p) => p._id == item._id);
      let paths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let path = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let point = mvcArray.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
      }
      this.newpath_tosave = paths;
      this.polygons_selecionne = polygons_edited;
    },
    oneditbuttonclick() {
      if (this.edit_active) {
        this.sauvgardeEdit();
      } else 
      {
        this.$toast.info("Cliquez pour modifier la parcelle", {
          position: "bottom-right",
          timeout: 2200,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          showCloseButtonOnHover: true,
          hideProgressBar: false,
          closeButton: "button",
          icon: "fas fa-edit",
        });
      }

      this.edit_active = !this.edit_active;
    },

    sauvgardeEdit() {
      if (this.newpath_tosave.length == 0) {
        if (this.polygons_selecionne)
          this.polygons_selecionne[0].poly[0].edit = false;
        return;
      }

      let id = this.polygons_selecionne[0]._id;
      let details = this.polygons_selecionne[0];
      let obj = [];
      this.newpath_tosave[0].map((item) =>
        obj.push({
          latitude: item.lat,
          longitude: item.lng,
        })
      );
      details.poly[0].coord = [];
      details.poly[0].coord = [obj];
      Node.editPolynode(id, details)
        .then((response) => {
          console.log("Success:", response);

          this.$toast.success("Enregistrement réussi !", {
            position: "bottom-right",
            timeout: 2200,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            showCloseButtonOnHover: true,
            hideProgressBar: false,
            closeButton: "button",
            icon: "fas fa-check-circle",
          });

          this.newpath_tosave = [];

          this.polygons_selecionne[0].poly[0].edit = false;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      // this.polygons = JSON.parse(JSON.stringify(this.polygons_initiale));
    },

    play_show() {
      if (this.playing) {
        this.playing = false;
        return;
      }

      this.playing = true;

      if (this.stop_position <= 0)
        this.stop_position = this.carouselItems.length - 1;

      let i = this.stop_position;
      const playNext = () => {
        if (i >= 0 && this.playing) {
          this.handleCardClick(this.carouselItems[i]);
          i--;
          setTimeout(playNext, 550); // Adjust time delay as needed
        }
        if (i < 0) this.playing = false;
        this.stop_position = i;
      };
      playNext();
    },

    selectButton(button) {
      this.activeButton = button;
      // Add any additional logic for when a button is clicked...
    },

    selectButtonprof(button) {
      this.profendeur = button;
      // Add any additional logic for when a button is clicked...

      this.handleCardClick(this.itemselect);
    },

    handleCardClick(item) {
      let temp = null;
      if (this.profendeur === "10 cm") temp = item.id;
      else if (this.profendeur === "25 cm") temp = item.id1;
      else if (this.profendeur === "40 cm") temp = item.id2;
      else if (this.profendeur === "55 cm") temp = item.id3;
      this.itemselect = item;
      this.selectedCard = item.key;
      this.polygons_satte = [];
      this.polygons_satte = this.convertGeoJsonToGmapPolygon(temp);

      if (this.polygons_satte.length > 0) {
        this.show_info_sattelite = true;
      }
    },

    getPolygonOptions(polygon) {
      let fillColor =
        polygon.capteurChoice == "satellite"
          ? "rgba(255, 138, 138, 0.5)"
          : "rgba(252, 252, 144, 0.5)";

      // Use isHovered to determine the strokeColor and strokeWeight
      let strokeColor = polygon.isHovered
        ? this.edit_active
          ? "#ff7300"
          : "#eaff00"
        : polygon.capteurChoice == "satellite"
        ? "#ff0000"
        : "#eaff00";
      let strokeWeight = polygon.isHovered ? 4 : 1;

      return {
        fillColor: fillColor,
        fillOpacity: 1,
        strokeColor: strokeColor,
        strokeWeight: strokeWeight,
        clickable: true,
        editable: false,
        draggable: false,
        zIndex: 1,
      };
    },

    getPolygonOptions2(poly) {
      return {
        fillColor:
          this.activeButton === "Absolu" ? poly.color : poly.color_min_max,
        fillOpacity: 1,
        strokeColor: poly.isHovered ? "#eaff00" : "#0093de",
        strokeWeight: poly.isHovered ? 0.5 : 0,
        clickable: true,
        editable: false,
        zIndex: 1,
      };
    },

    onMouseoverPolygon(poly) {
      this.$set(poly, "isHovered", true); // Vue's reactivity system will automatically update the polygon
    },

    onMouseoutPolygon(poly) {
      this.$set(poly, "isHovered", false);
    },

    onPolygonMouseOver(poly) {
      this.$set(poly, "isHovered", true); // Vue's reactivity system will automatically update the polygon
    },

    onPolygonMouseOut(poly) {
      this.$set(poly, "isHovered", false);
    },

    draw(event) {
      const latitude = event.latLng.lat();
      const longitude = event.latLng.lng();
      this.clickedPoints.push({ position: { lat: latitude, lng: longitude } });

      if (this.clickedPoints.length > 1) {
        this.drawPolyline();
      }
      if (this.clickedPoints.length > 2) {
        this.drawPolygon();
      }
    },

    drawPolyline() {
      const path = this.clickedPoints.map((marker) => marker.position);
      this.polylinePath = path;
    },

    drawPolygon() {
      this.polygonPaths = this.clickedPoints.map((marker) => marker.position);
    },

    deleteLastPoint() {
      this.clickedPoints.pop();
      this.polylinePath = this.clickedPoints.map((marker) => marker.position);
      this.polygonPaths = this.clickedPoints.map((marker) => marker.position);
    },

    onclearmap() {
      this.edit_active = false;

      this.carouselItems = [];
      this.polygons_satte = [];
      this.polygons = [];
      // this.polygons_initiale = [];
      this.stop_position = 0;
      /* Node.getNodesAquaedge().then((res) => {
        this.nodes = res;
        const polygonsTemp = res.map((item) => {
          item.poly = item.poly.map((poly) => {
            poly.coord = poly.coord[0].map((coord) => ({
              lat: coord.latitude,
              lng: coord.longitude,
            }));
            return poly;
          });
          return item;
        }); 
        this.polygons = polygonsTemp;
         this.polygons_initiale = JSON.parse(JSON.stringify(polygonsTemp));
        this.zoom_entier();
      }); */

      this.polygons = JSON.parse(JSON.stringify(this.polygons_initiale));

      this.zoom_entier();
    },

    toggleInfoWindow(index, event) {
      this.infoWindowPos = event.latLng;
      this.currentPolygonIndex = index;
    },
    processCoordinates(feature) {
      let polygonsCoords = [];

      const processSinglePolygon = (polygon) => {
        return polygon
          .map((coordPair) => {
            const lat = parseFloat(coordPair[1]);
            const lng = parseFloat(coordPair[0]);

            if (!isFinite(lat) || !isFinite(lng)) {
              console.error("Invalid coordinate:", coordPair);
              return null;
            }
            return { lat, lng };
          })
          .filter((coord) => coord !== null);
      };

      if (
        Array.isArray(feature.geometry.coordinates[0][0]) &&
        feature.geometry.coordinates[0][0].length > 2
      ) {
        // Handle as MultiPolygon
        feature.geometry.coordinates[0].forEach((polygon) => {
          const processedCoords = processSinglePolygon(polygon);

          if (processedCoords.length > 0) {
            polygonsCoords.push(processedCoords);
          }
        });
      } else {
        // Handle as single Polygon
        const processedCoords = processSinglePolygon(
          feature.geometry.coordinates[0]
        );
        if (processedCoords.length > 0) {
          polygonsCoords.push(processedCoords);
        }
      }

      return polygonsCoords;
    },
    convertGeoJsonToGmapPolygon(geoJson) {
      let i = 1;

      return geoJson.features.map((feature, index) => {
        const coords = this.processCoordinates(feature);

        const color = feature.properties.color;
        const color_min_max = feature.properties.color_min_max;

        let properties = feature.properties["soil_moisture"];

        if (this.profendeur === "10 cm")
          properties = feature.properties["soil_moisture"].toFixed(2);
        else if (this.profendeur === "25 cm")
          properties = feature.properties["soil_moisture"].toFixed(2);
        else if (this.profendeur === "40 cm")
          properties = feature.properties["soil_moisture"].toFixed(2);
        else if (this.profendeur === "55 cm")
          properties = feature.properties["soil_moisture"].toFixed(2);

        const min = feature.properties["min_soil_moisture"].toFixed(1);
        const max = feature.properties["max_soil_moisture"].toFixed(1);
        this.VALUE_MAX = max;
        this.VALUE_MIN = min;

        i++;
        return { coords, color, color_min_max, properties };
      });
    },

    getetodata() {
  let idParcel = this.polygons_selecionne[0]._id;

  // Use selectedYear and selectedMonth to set the date range for the whole month
  const startDate = new Date(this.selectedYear, this.selectedMonth - 1, 1); // Month is 0-indexed in JavaScript
  const endDate = new Date(this.selectedYear, this.selectedMonth, 0); // Last day of the previous month

  // Format the dates to YYYY-MM-DD
  const formattedStartDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
  const formattedEndDate = `${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;

  Node.getET0(idParcel, formattedStartDate, formattedEndDate).then((res) => 
  { 
    this.labelset0 = [];
    this.defaultDatasetset0[0].data = [];

    res.forEach((data) => {
      let date = new Date(data.Date);
      const day = date.getDate();
      const monthShort = date.toLocaleString("fr-FR", { month: "short" });
      this.labelset0.push(`${day} ${monthShort}`);
      this.defaultDatasetset0[0].data.push(data.value.toFixed(1));
    });
  });
},


    getimagesattlite(id) {
      this.mapOptions = {
        ...this.mapOptions,
        zoomControl: false,
        mapTypeControl: false,
      };

      this.defaultDatasets[0].data = [];
      this.defaultDatasets[1].data = [];
      this.defaultDatasets[2].data = [];
      this.defaultDatasets[3].data = [];
      this.labels = [];

      this.polygons_satte = [];

      this.list_polygonsatt = [];

      this.carouselItems = [];

      const getSoilMoistureColorminmax = (min, max, current) => {
        const range = max - min;
        const normalizedValue = (current - min) / range;

        if (normalizedValue < 0.33) {
          return "red";
        } else if (normalizedValue >= 0.33 && normalizedValue < 0.66) {
          return "green";
        } else {
          return "#0583D2";
        }
      };

      const getSoilMoistureColor = (soilMoisture) => {
        if (soilMoisture < 10) {
          return "red"; // Rouge
        } else if (soilMoisture >= 20 && soilMoisture < 40) {
          return "orange"; // Orange
        } else if (soilMoisture >= 40 && soilMoisture < 50) {
          return "yellow"; // Jaune
        } else if (soilMoisture >= 50 && soilMoisture < 60) {
          return "green"; // Vert
        } else if (soilMoisture >= 60 && soilMoisture < 70) {
          return "#B8E3FF";
        } else if (soilMoisture >= 70 && soilMoisture < 80) {
          return "#0583D2"; // Bleu
        } else {
          return "#16558F"; // Bleu Foncé
        }
      };

      Node.getSoilMoisture(id, this.selectedYear, this.selectedMonth).then
      (
        (res) => {

          console.log("Retourn::::");
          console.log(res);

        //  Uncaught (in promise) TypeError: Cannot read properties of undefined (reading 'error')

          if ( isEmpty(res)  )
          {

            this.$toast.error("Aucune donnée disponible", 
            {
          
                  position: "bottom-right",
                  timeout: 2200,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  showCloseButtonOnHover: true,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: "fas fa-exclamation-triangle",
              });

              this.loadingMarker.position = { lat: 0, lng: 0 };
          this.loadingMarker.icon = "";
          this.loadingMarker.shouldDisplayLoadingMarker = false;

            
            return;
          }




          this.loadingMarker.position = { lat: 0, lng: 0 };
          this.loadingMarker.icon = "";
          this.loadingMarker.shouldDisplayLoadingMarker = false;

          this.list_polygonsatt = res;

          let index = 1;
          this.list_polygonsatt.forEach((polygon) => {
            polygon.imageObject = JSON.parse(polygon.imageObject);

            const depth1_map = polygon.imageObject.depth1_map;
            const depth2_map = polygon.imageObject.depth2_map;
            const depth3_map = polygon.imageObject.depth3_map;
            const depth4_map = polygon.imageObject.depth4_map;
            let soilMoisture;

            depth1_map.features.forEach((feature) => {
              soilMoisture = feature.properties.soil_moisture;
              const minMoisture = feature.properties.min_soil_moisture;
              const maxMoisture = feature.properties.max_soil_moisture;
              feature.properties["color_min_max"] = getSoilMoistureColorminmax(
                minMoisture,
                maxMoisture,
                soilMoisture
              );
              feature.properties["color"] = getSoilMoistureColor(soilMoisture);
            });

            depth2_map.features.forEach((feature) => {
              soilMoisture = feature.properties.soil_moisture;
              feature.properties["color"] = getSoilMoistureColor(soilMoisture);
              const minMoisture = feature.properties.min_soil_moisture;
              const maxMoisture = feature.properties.max_soil_moisture;
              feature.properties["color_min_max"] = getSoilMoistureColorminmax(
                minMoisture,
                maxMoisture,
                soilMoisture
              );
            });
            depth3_map.features.forEach((feature) => {
              soilMoisture = feature.properties.soil_moisture;
              feature.properties["color"] = getSoilMoistureColor(soilMoisture);

              const minMoisture = feature.properties.min_soil_moisture;
              const maxMoisture = feature.properties.max_soil_moisture;
              feature.properties["color_min_max"] = getSoilMoistureColorminmax(
                minMoisture,
                maxMoisture,
                soilMoisture
              );
            });
            depth4_map.features.forEach((feature) => {
              soilMoisture = feature.properties.soil_moisture;
              feature.properties["color"] = getSoilMoistureColor(soilMoisture);

              const minMoisture = feature.properties.min_soil_moisture;
              const maxMoisture = feature.properties.max_soil_moisture;
              feature.properties["color_min_max"] = getSoilMoistureColorminmax(
                minMoisture,
                maxMoisture,
                soilMoisture
              );
            });

            const timestep = polygon.Datetime;

            this.defaultDatasets[0].data.push(
              polygon.imageObject.depth1_avg.toFixed(0)
            );

            if (polygon.imageObject.depth2_avg)
              this.defaultDatasets[1].data.push(
                polygon.imageObject.depth2_avg.toFixed(0)
              );

            if (polygon.imageObject.depth3_avg)
              this.defaultDatasets[2].data.push(
                polygon.imageObject.depth3_avg.toFixed(0)
              );

            if (polygon.imageObject.depth4_avg)
              this.defaultDatasets[3].data.push(
                polygon.imageObject.depth4_avg.toFixed(0)
              );

            const date = new Date(timestep);

            const hour = date.getHours();
            const day = date.getDate();

            const monthshort = date.toLocaleString("fr-FR", { month: "short" });

            const month = date.toLocaleString("fr-FR", { month: "long" });

            this.labels.push(`${day} ${monthshort} ${hour}:00`);

            let image = "";
            if (hour >= 1 && hour < 11) {
              image = require("../assets/icons/sun.png");
            } else if (hour >= 11 && hour < 18) {
              image = require("../assets/icons/dawn.png");
            } else if (hour >= 18 && hour <= 23) {
              image = require("../assets/icons/moon.png");
            }

            index++;

            this.carouselItems.push({
              key: index,
              id: depth1_map,
              id1: depth2_map,
              id2: depth3_map,
              id3: depth4_map,
              title: `${day}`,
              description: month,
              image: image,
            });
          });

          this.carouselItems.reverse();
          this.labels;
          this.defaultDatasets[0].data;
          this.defaultDatasets[1].data;
          this.defaultDatasets[2].data;
          this.defaultDatasets[3].data;
          this.handleCardClick(this.carouselItems[0]);
        }
      );
    },

    onPolygonClick(polygon) {
      if (polygon.capteurChoice == "capteur") {
        return;
      }

      if (this.edit_active == true) {
        if (this.polygons_selecionne) {
          if (this.polygons_selecionne[0]) {
            this.polygons_selecionne[0].poly[0].edit = false;
            this.sauvgardeEdit();
          }
        }

        polygon.poly[0].edit = true;
        this.polygons_selecionne = [polygon];
        return;
      }

      this.stop_position = 0;
      if (this.polygons_selecionne) {
        console.log(this.polygons_selecionne[0]);
        this.onMouseoutPolygon(this.polygons_selecionne[0].Coord);
      }

      this.carouselItems = [];
      this.polygons_satte = [];
      this.polygons = JSON.parse(JSON.stringify(this.polygons_initiale));

      let center = this.getPolygonCenter(polygon.Coord);

      this.loadingMarker.position = {
        lat: center.lat,
        lng: center.lng,
      };

      this.loadingMarker.icon = require("../assets/icons/loading.png");
      this.loadingMarker.shouldDisplayLoadingMarker = true;

      const id = polygon._id;

      this.selected_polygon = id;
      const date = new Date().toISOString().split("T")[0];
      const n_days = 10;

      this.polygons_selecionne = this.polygons.filter((p) => p._id == id);

      this.getetodata();
      this.getimagesattlite(id);

      this.polygons = this.polygons.filter((p) => p._id !== id);
      let coordinates = this.polygons_selecionne[0].Coord;
      let minLat = coordinates[0].lat;
      let maxLat = coordinates[0].lat;
      let minLng = coordinates[0].lng;
      let maxLng = coordinates[0].lng;
      for (let i = 1; i < coordinates.length; i++) {
        const coord = coordinates[i];
        minLat = Math.min(minLat, coord.lat);
        maxLat = Math.max(maxLat, coord.lat);
        minLng = Math.min(minLng, coord.lng);
        maxLng = Math.max(maxLng, coord.lng);
      }
      const centerLat = (minLat + maxLat) / 2;
      const centerLng = (minLng + maxLng) / 2;

      this.center = { lat: centerLat, lng: centerLng };

      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(minLat, minLng),
        new google.maps.LatLng(maxLat, maxLng)
      );
      this.$refs.mapRef.$mapObject.fitBounds(bounds);
    },

    setMapHeight() {
      const windowHeight = window.innerHeight;
      const navbarHeight = 0; // Adjust if you have a fixed navbar or header
      const mapHeight = windowHeight - navbarHeight;
      this.mapHeight = `${mapHeight - 70}px`;
    },

    zoom_entier() {
      if (!this.polygons || this.polygons.length === 0) {
        return;
      }

      let bounds = new google.maps.LatLngBounds();
      this.polygons.forEach((polygon) => {
        polygon.Coord.forEach((path) => {
          bounds.extend(path);
        });
      });
      this.$refs.mapRef.$mapObject.fitBounds(bounds);
    },

    profilePath(position, id) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        if (map.getZoom() < 12) {
          map.panTo(position);
          map.setZoom(12);
        } else if (map.getZoom() == 12) {
          map.panTo(position);
          map.setZoom(18);
        } else {
          Node.getNodeDetails(id).then((res) => {
            if (!isEmpty(res)) {
              this.p1 = res.port1;
              this.p2 = res.port2;
              this.p3 = res.port3;
              this.p4 = res.port4;
              this.p5 = res.port5;
              this.p6 = res.port6;
              this.nbr_port = res.nbr_port;
              this.prf = res.profondeur;
              if (id[0] == "Z" || id[0] == "z") {
                router.push(
                  `/dashboard?id=${id}&nbr=${
                    this.nbr_port
                  }&p1=${encodeURIComponent(this.p1)}&p2=${encodeURIComponent(
                    this.p2
                  )}&p3=${encodeURIComponent(this.p3)}&p4=${encodeURIComponent(
                    this.p4
                  )}&p5=${encodeURIComponent(this.p5)}&p6=${encodeURIComponent(
                    this.p6
                  )}&prf=${this.prf}`
                );
              } else
                router.push(
                  `/dashboard?id=${id}&nbr=4&p1=${encodeURIComponent(
                    this.p1
                  )}&p2=${encodeURIComponent(this.p2)}&p3=${encodeURIComponent(
                    this.p3
                  )}&p4=${encodeURIComponent(this.p4)}&p5=${encodeURIComponent(
                    this.p5
                  )}&p6=${encodeURIComponent(this.p6)}&prf=${this.prf}`
                );
            }
          });
        }
      });

      // router.push(`/dashboard?id=${id}`);
    },

    getPolygonCenter(coords) {
      let x = 0,
        y = 0,
        len = coords.length;
      for (let i = 0; i < len; i++) {
        x += coords[i].lat;
        y += coords[i].lng;
      }
      return { lat: x / len, lng: y / len };
    },
    checkGoogleMapsAvailability() {
      if (typeof google === "undefined" || typeof google.maps === "undefined") {
        setTimeout(this.checkGoogleMapsAvailability, 1000); // Check again after a delay
      } else {
        this.initializeMap();
      }
    },

    getAddressData(addressData, placeResultData, id) {
      console.log("Updating map center and zoom");
      this.center = {
        lat: placeResultData.geometry.location.lat(),
        lng: placeResultData.geometry.location.lng(),
      };
      this.zoom = 14;
      console.log(this.center, this.zoom);
    },
  },
  mounted() {
    this.setMapHeight();

    $(this.$el).carousel();

    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
      this.initMarkers();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.setMapHeight);
  },
  created() {
    Parcel.getParcel().then((res) => {
      this.nodes = res;
      let polygonsTemp = res.map((item) => {
        item.Coord = item.Coord.map((position) => {
          return {
            lat: position[0],
            lng: position[1],
          };
        });
        return item;
      });
      this.polygons = polygonsTemp;

      this.polygons_initiale = JSON.parse(JSON.stringify(polygonsTemp));

      this.zoom_entier();
    });

    Node.getNodes().then((res) => {
      for (const item of res) {
        this.markers.push({
          position: {
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
          },
          title: item.FarmerName,
          id: item.NodeId,
        });
      }

      console.log("markers lenght : ");
      console.log(this.markers.length);

      this.$nextTick(() => {
        this.initMarkerCluster();
      });
    });
  },
  watch: {
    markers: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.$nextTick(this.initMarkerCluster);
        }
      },
      deep: true,
      immediate: false, // Change to true if you want this to run immediately on component creation
    },

    selectedYear(newVal) 
    {
      if (newVal && this.selectedMonth) 
      { 
        let center = this.getPolygonCenter(this.polygons_selecionne[0].Coord);
        this.loadingMarker.position = {
          lat: center.lat,
          lng: center.lng,
        };
        this.loadingMarker.icon = require("../assets/icons/loading.png");
        this.loadingMarker.shouldDisplayLoadingMarker = true;
        this.getimagesattlite(this.selected_polygon);

        this.getetodata();
      }
    },
    selectedMonth(newVal) 
    {
      if (newVal && this.selectedYear) 
      {
        let center = this.getPolygonCenter(this.polygons_selecionne[0].Coord);
        this.loadingMarker.position = {
          lat: center.lat,
          lng: center.lng,
        };
        this.loadingMarker.icon = require("../assets/icons/loading.png");
        this.loadingMarker.shouldDisplayLoadingMarker = true;
        this.getimagesattlite(this.selected_polygon);
        this.getetodata();
      }
    },
  },
};
</script>

<style>
button[title="Afficher les images satellite"] {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 13px !important;
  color: #428870 !important;
  background: #ffffff !important;
  border: 2px solid #428874 !important;
  border-radius: 6px !important;
  padding: 10px 20px !important;
  text-align: center !important;
  text-decoration: none !important;
  margin: 0 4px !important;
  cursor: pointer !important;
  transition: all 0.2s ease-in-out !important;
}

button[title="Afficher un plan de ville"] {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 13px !important;
  color: #428870 !important;
  border: 2px solid #428874 !important;
  border-radius: 6px !important;
  padding: 10px 20px !important;
  margin: 0 4px !important;
  cursor: pointer !important;
  transition: all 0.2s ease-in-out !important;
}

li[title="Afficher les images satellite avec le nom des rues"] {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 13px !important;
  color: #428870 !important;
  background-color: #f8f9fa !important;
  border-radius: 10px !important;
  padding: 5px 10px !important;
}

li[title="Afficher le relief sur la carte"] {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 13px !important;
  color: #428870 !important;
  background-color: #f8f9fa !important;
  border-radius: 10px !important;
  padding: 5px 10px !important;
}
#searchInput {
  /* width :3.5%;
  position: absolute;
  top: 95%;
  transform: translate(0, -50%); */
}
</style>
<style scoped src="./maps.css"></style>
